import { IconArrowDownOutline } from '@icons/IconArrowDownOutline'
import { IconArrowLeftOutline } from '@icons/IconArrowLeftOutline'
import { IconArrowRightOutline } from '@icons/IconArrowRightOutline'
import { IconArrowUpOutline } from '@icons/IconArrowUpOutline'
import { IconMinusOutline } from '@icons/IconMinusOutline'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { Button, ButtonProps } from '@/components/shadcn/button'
import { cn } from '@/lib/utils'
import { IconDeleteOutline } from '@icons/IconDeleteOutline'
import { useAppPageLayout } from '../../useAppPageLayout'
import { useIsPageBuilder } from '@/catalog-apps/hooks/useIsPageBuilder'

function SingleButton({ onClick, icon, className, ...props }: ButtonProps & { icon: React.ReactNode }) {
  return (
    <Button size="icon" className={cn('size-6 rounded-full', className)} onClick={onClick} {...props}>
      {icon}
    </Button>
  )
}

export function LayoutButtons({ containerId }: { containerId: string }) {
  const isPageBuilder = useIsPageBuilder()
  const {
    numberOfContainers,
    handleDeleteContainer,
    incrVerticalTop,
    moveUp,
    decrVerticalTop,
    decrHorizontalRight,
    moveRight,
    incrHorizontalRight,
    incrVerticalBottom,
    moveDown,
    decrVerticalBottom,
    decrHorizontalLeft,
    moveLeft,
    incrHorizontalLeft,
  } = useAppPageLayout()
  return (
    <>
      <div className="absolute -top-3 flex w-full justify-center gap-2 text-foreground/50">
        <SingleButton onClick={() => decrVerticalTop(containerId)} icon={<IconMinusOutline className="size-4" />} />
        <SingleButton onClick={() => moveUp(containerId)} icon={<IconArrowUpOutline className="size-4" />} />
        <SingleButton onClick={() => incrVerticalTop(containerId)} icon={<IconPlusOutline className="size-4" />} />
        {isPageBuilder && numberOfContainers > 1 && (
          <SingleButton
            onClick={() => handleDeleteContainer(containerId)}
            icon={<IconDeleteOutline className="size-4" />}
            variant="outline"
            className="absolute right-0 size-8 translate-x-1/2 border-red-600 bg-red-100 text-red-600"
          />
        )}
      </div>
      <div className="absolute -right-3 top-1/2 z-10 flex -translate-y-1/2 flex-col gap-2">
        <SingleButton onClick={() => decrHorizontalRight(containerId)} icon={<IconMinusOutline className="size-4" />} />
        <SingleButton onClick={() => moveRight(containerId)} icon={<IconArrowRightOutline className="size-4" />} />
        <SingleButton onClick={() => incrHorizontalRight(containerId)} icon={<IconPlusOutline className="size-4" />} />
      </div>
      <div className="absolute -bottom-3 left-1/2 z-10 flex -translate-x-1/2 gap-2">
        <SingleButton onClick={() => decrVerticalBottom(containerId)} icon={<IconMinusOutline className="size-4" />} />
        <SingleButton onClick={() => moveDown(containerId)} icon={<IconArrowDownOutline className="size-4" />} />
        <SingleButton onClick={() => incrVerticalBottom(containerId)} icon={<IconPlusOutline className="size-4" />} />
      </div>
      <div className="absolute -left-3 top-1/2 flex -translate-y-1/2 flex-col gap-2">
        <SingleButton onClick={() => decrHorizontalLeft(containerId)} icon={<IconMinusOutline className="size-4" />} />
        <SingleButton onClick={() => moveLeft(containerId)} icon={<IconArrowLeftOutline className="size-4" />} />
        <SingleButton onClick={() => incrHorizontalLeft(containerId)} icon={<IconPlusOutline className="size-4" />} />
      </div>
    </>
  )
}
